import { queryClient, useMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import type { FullTeamGroupResponse, GetTeamGroupsResponse, NewTeamGroupRequest } from '../../../../../shared/types/routes/teamGroups';

import { useTeamGroupsQueryKey } from './useTeamGroups';

//  Function for creating a new TeamGroup.
function createTeamGroup(newTeamGroup: NewTeamGroupRequest): Promise<Response> {
  return post<NewTeamGroupRequest, void>('/api/teams/groups', newTeamGroup);
}

//  This is a helper function to create a new empty team group
//  so that we can add it to the cache.
const createNewEmptyTeam = (newTeamGroup: NewTeamGroupRequest): FullTeamGroupResponse => ({
  ...newTeamGroup,
  id: 0,
  teams: [],
  members: [],
});

/**
 * Hook used to create a new TeamGroup.
 */
export default function useCreateTeamGroup(newTeamGroup: NewTeamGroupRequest) {
  return useMutation({
    mutationFn: () => createTeamGroup(newTeamGroup),
    onSuccess: () => {
      //  Add the new team group to the cache
      queryClient.setQueryData(useTeamGroupsQueryKey, (oldData?: GetTeamGroupsResponse) => {
        const newTeamGroupToCache = createNewEmptyTeam(newTeamGroup);
        if (!oldData) {
          return [newTeamGroupToCache] as GetTeamGroupsResponse;
        }
        return [...oldData, newTeamGroupToCache] as GetTeamGroupsResponse;
      });

      //  Re-fetch the team groups
      queryClient.invalidateQueries({ queryKey: useTeamGroupsQueryKey });
    },
  });
}
